import { api } from '../../AxiosConfig';

class EstoqueService {
    createItem(data: any) {
        return api.post('/estoque/itens/create', data);
    }

    updateItem(id: string, update: any) {
        return api.post('/estoque/itens/update', { id, update });
    }

    deleteItem(id: string) {
        return api.post('/estoque/itens/delete', { id });
    }

    findItems(params?: any) {
        return api.get('/estoque/itens/findAll', { params });
    }

    getItem(id: string) {
        return api.get(`/estoque/itens/get/${id}`);
    }

    findMovementsByItem(itemId: string, params?: any) {
        return api.get(`/estoque/movimentos/findByItem/${itemId}`, { params });
    }

    createMovement(data: any) {
        return api.post('/estoque/movimentos/create', data);
    }

    getResumo() {
        return api.get('/estoque/resumo/findAll');
    }

    getRecommendations() {
        return api.get('/estoque/recomendacoes/compra');
    }

    upsertRecipe(data: any) {
        return api.post('/estoque/receitas/upsert', data);
    }

    getRecipeByServico(servicoId: string) {
        return api.get(`/estoque/receitas/getByServico/${servicoId}`);
    }

    getRelatorioConsumo(params: any) {
        return api.get('/estoque/relatorios/consumo', { params });
    }
}

export { EstoqueService };
